var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    [
      _vm.orderId
        ? _c(
            "v-row",
            { staticClass: "mb-7" },
            [
              !_vm.orderId.resultText
                ? _c(
                    "v-col",
                    { staticClass: "text-center", attrs: { cols: "12" } },
                    [
                      _c("h2", { staticClass: "mt-7 mb-3" }, [
                        _vm._v(
                          _vm._s(_vm.$t("checkoutSuccess.successfulOrder"))
                        )
                      ]),
                      _c("p", [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("checkoutSuccess.orderNumber")) +
                            ": " +
                            _vm._s(_vm.orderId.orderNumber) +
                            " "
                        )
                      ]),
                      _vm.orderId.bankAccount
                        ? _c("div", { staticClass: "mb-3" }, [
                            _c("div", [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t("checkoutSuccess.bankAccount")
                                  ) +
                                  ": "
                              ),
                              _c("strong", [
                                _vm._v(_vm._s(_vm.orderId.bankAccount))
                              ])
                            ]),
                            _c("div", [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$t("checkoutSuccess.amount")) +
                                  ": "
                              ),
                              _c("strong", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t("homepage.currency", {
                                        price: _vm.orderId.totalWithVat
                                      })
                                    ) +
                                    " "
                                )
                              ])
                            ]),
                            _c("div", [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t("checkoutSuccess.variableSymbol")
                                  ) +
                                  ": "
                              ),
                              _c("strong", [
                                _vm._v(_vm._s(_vm.orderId.bankVariableSymbol))
                              ])
                            ])
                          ])
                        : _vm._e(),
                      _vm.orderId.spaidQR
                        ? _c("div", { staticClass: "mb-3" }, [
                            _c("img", {
                              attrs: { src: _vm.qrCode, alt: "QrCode" }
                            })
                          ])
                        : _vm._e(),
                      _vm.$vuetify.breakpoint.xsOnly && _vm.orderId.spaidFile
                        ? _c(
                            "div",
                            { staticClass: "my-3 mb-5" },
                            [
                              _c("div", { staticClass: "my-3" }, [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$t(
                                        "checkoutSuccess.payByApplicationText"
                                      )
                                    ) +
                                    " "
                                )
                              ]),
                              _c(
                                "v-btn",
                                {
                                  attrs: {
                                    color: "primary",
                                    depressed: "",
                                    small: "",
                                    tile: "",
                                    href: _vm.orderId.spaidFile
                                  }
                                },
                                [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "checkoutSuccess.payByApplicationButton"
                                      )
                                    )
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _c("p", [
                        _vm._v(_vm._s(_vm.$t("checkoutSuccess.notification")))
                      ]),
                      !_vm.loading
                        ? _c(
                            "v-row",
                            { staticClass: "mb-4" },
                            [
                              _c(
                                "v-col",
                                {
                                  staticClass: "text-center pb-1",
                                  attrs: { cols: "12" }
                                },
                                [
                                  _c("h2", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "checkoutSuccess.downloadTickets"
                                        )
                                      )
                                    )
                                  ])
                                ]
                              ),
                              _c(
                                "v-col",
                                {
                                  attrs: {
                                    cols: "12",
                                    sm: "6",
                                    "offset-sm": "3"
                                  }
                                },
                                _vm._l(_vm.groupProductReadyQrCodes, function(
                                  group,
                                  category
                                ) {
                                  return _c(
                                    "div",
                                    { key: category },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "text-subtitle-1 mb-1 mt-4 text-left"
                                        },
                                        [_vm._v(_vm._s(category))]
                                      ),
                                      _c(
                                        "v-expansion-panels",
                                        _vm._l(group, function(item, index) {
                                          return _c(
                                            "v-expansion-panel",
                                            { key: item.id },
                                            [
                                              _c("v-expansion-panel-header", [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      "" +
                                                        (index + 1) +
                                                        ". " +
                                                        item.name
                                                    ) +
                                                    " "
                                                )
                                              ]),
                                              _c(
                                                "v-expansion-panel-content",
                                                [
                                                  item.registrationUrl
                                                    ? _c(
                                                        "v-btn",
                                                        {
                                                          attrs: {
                                                            large: "",
                                                            href:
                                                              item.registrationUrl,
                                                            target: "_blank",
                                                            tile: "",
                                                            color: "primary",
                                                            depressed: ""
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "checkoutSuccess.ticketRegistration"
                                                              )
                                                            )
                                                          )
                                                        ]
                                                      )
                                                    : item.giftCardUrl
                                                    ? _c(
                                                        "v-btn",
                                                        {
                                                          attrs: {
                                                            large: "",
                                                            href:
                                                              item.giftCardUrl,
                                                            target: "_blank",
                                                            tile: "",
                                                            color: "primary",
                                                            depressed: ""
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.$t(
                                                                "checkoutSuccess.giftCard"
                                                              )
                                                            )
                                                          )
                                                        ]
                                                      )
                                                    : _c("div", [
                                                        _c("img", {
                                                          attrs: {
                                                            src: item.qrCode,
                                                            alt: item.name
                                                          }
                                                        }),
                                                        _c("p", [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "checkoutSuccess.ticketNumber"
                                                                )
                                                              ) +
                                                              ": "
                                                          ),
                                                          _c("strong", [
                                                            _vm._v(
                                                              _vm._s(
                                                                item.ticketNumber
                                                              )
                                                            )
                                                          ])
                                                        ])
                                                      ])
                                                ],
                                                1
                                              )
                                            ],
                                            1
                                          )
                                        }),
                                        1
                                      )
                                    ],
                                    1
                                  )
                                }),
                                0
                              ),
                              _c(
                                "v-col",
                                {
                                  staticClass: "text-center",
                                  attrs: { cols: "12" }
                                },
                                [
                                  _vm.canDownloadPdf
                                    ? _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            large: "",
                                            href: _vm.downloadPdfUrl,
                                            target: "_blank",
                                            tile: "",
                                            color: "primary",
                                            depressed: ""
                                          }
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.$t(
                                                "checkoutSuccess.downloadPdf"
                                              )
                                            )
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "v-btn",
                        {
                          attrs: { depressed: "", tile: "" },
                          on: {
                            click: function($event) {
                              return _vm.$router.push("/")
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("checkoutSuccess.backToStore")))]
                      )
                    ],
                    1
                  )
                : _c(
                    "v-col",
                    { staticClass: "text-center", attrs: { cols: "12" } },
                    [
                      _c("h2", { staticClass: "mt-7 mb-3" }, [
                        _vm._v(_vm._s(_vm.$t("checkoutSuccess.orderError")))
                      ]),
                      _c("p", [
                        _vm._v(
                          " " +
                            _vm._s(_vm.$t("checkoutSuccess.orderNumber")) +
                            ": " +
                            _vm._s(_vm.orderId.orderNumber) +
                            " "
                        )
                      ]),
                      _c("p", [
                        _vm._v(
                          " " + _vm._s(_vm.$t("checkoutSuccess.error")) + ": "
                        ),
                        _c("span", {
                          domProps: {
                            textContent: _vm._s(_vm.orderId.resultText)
                          }
                        })
                      ]),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "primary", depressed: "", tile: "" },
                          on: {
                            click: function($event) {
                              return _vm.$router.push("/")
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("checkoutSuccess.backToStore")))]
                      )
                    ],
                    1
                  )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }